export const SHIPPING_TASK_STATUSES = {
  PICKING: 1,
  SHIPPING: 2,
  SHIPPED: 3,
};
